import { render, staticRenderFns } from "./DashboardRechnungswesen.vue?vue&type=template&id=c4dc7584&scoped=true"
import script from "./DashboardRechnungswesen.vue?vue&type=script&lang=js"
export * from "./DashboardRechnungswesen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4dc7584",
  null
  
)

export default component.exports